export const DEFAULT_COLUMN_WIDTH = 800
